/* tslint:disable */
import React from 'react';
import styled from '@emotion/styled';
import Layout from '../components/Common/Layout';
import { PinkLinkButton } from '../elements/LinkButton';
import theme from '../styles/theme';

const Body = styled('div')`
  padding-top: 3em;
  text-align: center;

  p {
    font-size: ${theme.fontSizes.xlarge};
  }

  a {
    line-height: 1em;
    :after {
      content: ' →';
    }
  }
`;

// @ts-ignore
/* tslint:disable */
const PageNotFound = ({ data, pageContext }) => {
  // @ts-ignore
  const content = data || {
    title: `Page Not Found`,
    body: `Get back to retiring fearlessly.`,
    cta: {
      link: `/`,
      copy: `Back to Home`
    }
  };
  return (
    <Layout pageContext={pageContext} showContactUsFooter={false}>
      <Body>
        <h2>{data ? data.title : 'Page Not Found'}</h2>
        <p>{data ? data.body : 'Get back to retiring fearlessly.'}</p>
        <PinkLinkButton to={data ? data.cta.link : '/'} title={data ? data.cta.copy : 'Back To Home'}>
          {data ? data.cta.copy : 'Back To Home'}
        </PinkLinkButton>
      </Body>
    </Layout>
  );
};

export default PageNotFound;
